import { FormFieldControlled } from "components/UI/FormField/FormFieldControlled";
import { RequestTypeSelect } from "components/UI/RequestTypeSelect";
import { ContainerTrackingCheckboxGroupData } from "constants/checkboxGroupData.constants";
import { INPUT_FIELD_NAMES } from "constants/fieldNames.constans";
import { VALIDATION_SCHEMA } from "constants/validationSchema.constans";
import styles from "../index.module.scss";

export const ContainerTrackingIntegration = () => {
  return (
    <>
      <div className={styles.wrapperInputs}>
        <FormFieldControlled
          rules={VALIDATION_SCHEMA.toolInfo.required}
          labelTitle="How many shipments do you need to track per month?"
          fieldName={INPUT_FIELD_NAMES.containerTrackingmonthly_shipments}
          className={styles.inputShipments}
        />
        <FormFieldControlled
          rules={VALIDATION_SCHEMA.toolInfo.required}
          labelTitle="How many searches on your website do you expect per month (all users)?"
          fieldName={INPUT_FIELD_NAMES.containerTrackingSearchesPerMonth}
          className={styles.inputSearches}
        />
      </div>
      <FormFieldControlled
        rules={VALIDATION_SCHEMA.toolInfo.required}
        labelTitle="How many licenses (domains) do you need?"
        fieldName={INPUT_FIELD_NAMES.containerTrackingLicences}
        className={styles.licence}
      />
      <RequestTypeSelect
        rules={VALIDATION_SCHEMA.toolInfo.oneValue}
        fieldName={INPUT_FIELD_NAMES.containerTrackingrequest_types}
        label="type of request?"
        placeholder="Select request type"
        options={ContainerTrackingCheckboxGroupData}
        className={styles.requestTypeSelect}
      />
    </>
  );
};
